import { Injectable } from '@angular/core'
import { EMPTY, Observable, throwError } from 'rxjs'
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http'
import { environment } from '../../environments/environment'
import { catchError, retry } from 'rxjs/operators';
import { Router } from '@angular/router';
import { apiErrorResponse } from '../models/error-models/apiErrorResponse';

@Injectable({
  providedIn: 'root'
})
export class GenericService {
  options = {};
  token: string = "";
  private readonly apiBaseUrl = environment.apis.default.baseUrl + environment.apis.default.url;
  constructor(private httpClient: HttpClient,
    private router: Router) {
    this.options = {
      responseType: 'json',
    }
  }

  postThirdPartyResponse<T>(url: string, body: any): Observable<T> {
    const headers = { 'Content-Type': 'application/json' };
    return this.httpClient.post<T>(url, body, { headers })
      .pipe(
        retry(0),
        catchError(this.handleError));
  }

  
  postThirdPartyFormData<T>(url: string, data: FormData): Observable<T> {
    return this.httpClient.post<T>(url, data)
      .pipe(
        retry(0),
        catchError(this.handleError)
      );
  }

  getThirdPartyResponse<T>(url: string): Observable<T> {
    return this.httpClient
      .get<T>(`${url}`, this.options)
      .pipe(
        retry(0),
        catchError(this.handleError));
  }
  getBinary(url: string): Observable<HttpResponse<ArrayBuffer>> {
    return this.httpClient.get(
      `${this.apiBaseUrl}/${url}`,
      {
        responseType: 'arraybuffer' as 'arraybuffer',
        observe: 'response' as 'response'
      }
    ).pipe(
      retry(0),
      catchError(this.handleError)) as Observable<HttpResponse<ArrayBuffer>>;
  }
  getBinaryPost(url: string, body: any): Observable<HttpResponse<ArrayBuffer>> {
    return this.httpClient.post(
      `${this.apiBaseUrl}/${url}`,
      body,
      {
        headers: {
          'Content-Type': 'application/json',
        },
        responseType: 'arraybuffer' as 'arraybuffer',
        observe: 'response' as 'response'
      }
    ).pipe(
      retry(0),
      catchError(this.handleError)
    ) as Observable<HttpResponse<ArrayBuffer>>;
  }
  
  get<T>(url: string, p0?: { params: any; }): Observable<T> {
    return this.httpClient
      .get<T>(`${this.apiBaseUrl}/${url}`, {
        ...this.options,
        ...p0
      })
      .pipe(
        retry(0),
        catchError(this.handleError));
  }

  delete<T>(url: string): Observable<T> {
    return this.httpClient
      .delete<T>(`${this.apiBaseUrl}/${url}`, this.options)
      .pipe(catchError(this.handleError));
  }

  post<T>(url: string, data: any): Observable<T> {
    return this.httpClient
      .post<T>(`${this.apiBaseUrl}/${url}`, data, this.options)
      .pipe(catchError(this.handleError));
  }



  postFormData<T>(url: string, data: FormData): Observable<T> {
    const options = {
        responseType: 'json' as 'json'
    };
    return this.httpClient
      .post<T>(`${this.apiBaseUrl}/${url}`, data, options)
      .pipe(catchError(this.handleError));
  }

  putFormData<T>(url: string, data: FormData): Observable<T> {
    const options = {
        responseType: 'json' as 'json'
    };
    return this.httpClient
      .put<T>(`${this.apiBaseUrl}/${url}`, data, options)
      .pipe(catchError(this.handleError));
  }

  put<T>(url: string, data: any): Observable<T> {
    return this.httpClient
      .put<T>(`${this.apiBaseUrl}/${url}`, data, this.options)
      .pipe(catchError(this.handleError));
  }

  patch<T>(url: string, data: any): Observable<T> {
    return this.httpClient
      .patch<T>(`${this.apiBaseUrl}/${url}`, data, this.options)
      .pipe(catchError(this.handleError));
  }

  private handleError = (error: HttpErrorResponse) => {
    if (error.status === 0) {
    } else if (error.status === 403 || error.status === 401) {
      const isThirdPartyRequest = error.url?.includes('www.googleapis.com') ||
        error.url?.includes('youtube.com') ||
        error.url?.includes('blog.gradpilots.com') ||
        error.url?.includes('azurewebsites.net'); 

      const errorUrlLower = error.url?.toLowerCase() || '';
      const isNonCriticalRequest = errorUrlLower.includes('mindler/testrequest') ||
        errorUrlLower.includes('mindler/test/request');

      if (!isThirdPartyRequest && !isNonCriticalRequest) {
        const currentUrl = this.router.url.toLowerCase();
        const isAuthPage = currentUrl.includes('/signin') || currentUrl.includes('/partner-signin') || currentUrl.includes('/signup');

        if (!isAuthPage) {
          if (error.status === 401) {
            const isStudentPortal = currentUrl.includes('/portal/') || currentUrl === '/portal';
            const redirectPath = isStudentPortal ? '/signin' : '/partner-signin';
            this.router.navigate([redirectPath]);
          } else {
            this.router.navigate(['/access-denied']);
          }
        }
      }
      return throwError(() => new Error(error.status.toString()));
    } else if (error.status === 404) {
      return throwError(() => new Error(error.status.toString()));
    } else if (error.status === 400) {
      return throwError(() => new Error(this.formatApiError(error.error as apiErrorResponse)));
    } else {
    }
    return throwError(() => new Error('Something bad happened; please try again later.'));
  };

  private formatApiError(apiError: apiErrorResponse): string {
    let apiErrorMessage = '';
    if (apiError.errors.length > 0) {
      apiErrorMessage = apiError.errors[0].message;
    }
    return apiErrorMessage;
  }
}
